import { ICellRendererParams } from "ag-grid-community";
import { Kinds } from "constants/product-collection";

export enum TotalTypes {
    Units = "units",
    Skus = "skus",
    Depth = "depth",
    Wholesale = "wholesale",
    Retail = "retail",
    AvgWholesale = "avg_wholesale",
    AvgRetail = "avg_retail",
}

export enum PlanMetricRows {
    Plan = "plan",
    Total = "total",
    Diff = "diff",
}

export interface ICurrency {
    symbol: string;
    decimal_places: number;
    currency_code?: string;
}

export interface IPercentage {
    decimal_places: number;
}

export interface NumberFormat {
    currency?: ICurrency;
    percentage?: IPercentage;
}

export interface IPinnedRowsRenderersComponentProps {
    fieldName: string;
    totalType: TotalTypes;
    currency?: {
        symbol: string;
        decimal_places: number;
    };
    style?: React.CSSProperties;
    groupId?: string;
    doorId?: string;
    classificationName?: string;
    classificationValue?: string;
    colType?: string;
    data?: any;
    total: number;
    plan: number;
}

export interface IAllocationReferenceFields {
    retailFieldName: string;
    wholesaleFieldName: string;
}

export interface IOwnProps extends ICellRendererParams {
    kind: Kinds;
    style?: React.CSSProperties;
    allocationReferenceFields: IAllocationReferenceFields;
    groupId?: string;
    doorId?: string;
    classificationName?: string;
    classificationValue?: string;
    dimensionPlanMetrics?: string[];
}

export interface IReduxProps {
    displayPlanMetrics: boolean;
    displayTotals: boolean;
    total: number;
    plan: number;
    reviewPlan: any;
    dimensionFilters: string[][];
    totalType: TotalTypes;
}
